import { Link } from "gatsby"
import React from "react"

const Menus = () => {
  return(
      <React.Fragment>
        <li><Link to ="/" activeClassName="active">Home</Link></li>          
        <li><Link to ="/ielts_academic/listening/" activeClassName="active">IELTS Academic </Link></li>         
        <li><Link to ="/ielts_academic/listening/">IELTS General</Link></li>          
        <li><Link to ="/ielts_academic/listening/">Duolingo</Link></li>         
        <li><Link to ="/ielts_academic/listening/">SAT</Link></li>          
        <li><Link to ="/ielts_academic/listening/">GRE</Link></li>          
        <li><Link to ="/ielts_academic/listening/">PTE</Link></li>          
        <li><Link to ="/ielts_academic/listening/">TOFEL</Link></li>          
        <li><Link to ="/">Contact</Link></li>
      </React.Fragment>
  )
}


export default Menus
